import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as offeringDomain from '../../offering-domain'

export const RESOURCE = {
  payload: {
    description: 'The association(s) between offerings and domains',
    dimension: offeringDomain.RESOURCE.payload,
    level: 0,
    name: 'Offering Domain',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
